import { memo } from 'react';

import { useNumberFormatter } from '@myn/mui';

import FormattedAutocomplete from '../../../../../../molecules/FormattedAutocomplete/FormattedAutocomplete.jsx';
import { BuilderTableColumn, BuilderTableRow } from '../../../../types.js';
import FormattedField from '../FormattedField/FormattedField.jsx';
import useSelectableValueField from '../hooks/useSelectableValueField.js';
import TableEditCell from '../TableEditCell/TableEditCell.jsx';
import AutocompleteWrapper from '../wrappers/AutocompleteWrapper.jsx';

export type Props = {
  value: string | null;
  column: BuilderTableColumn;
  row: BuilderTableRow;
  cellColor: string;
};

const SelectNumberValue = memo(({ value, column, row, cellColor }: Props) => {
  const { scale } = row.original;

  const {
    isFieldFocused,
    isReadOnlyField,
    isResetBtnShown,
    handleOpenMenu,
    handleCloseMenu,
    handleChangeValue,
    handleResetValue,
  } = useSelectableValueField({
    value,
    column,
    row,
  });

  const formatterOptions = {
    min: 0,
    minDecimals: column.decimals,
    maxDecimals: column.decimals,
  };
  const formatter = useNumberFormatter({
    options: formatterOptions,
  });

  if (isReadOnlyField) {
    return (
      <FormattedField
        scale={scale}
        value={value}
        variant="number"
        decimalLimit={column.decimals}
        color={cellColor}
      />
    );
  }

  if (!isFieldFocused) {
    return (
      <TableEditCell
        scale={scale}
        isDeleteButtonShown={isResetBtnShown}
        deleteValueFunc={handleResetValue}
        showEditModeFunc={handleOpenMenu}
        startMeasurePerformance={column.startMeasurePerformance}
        value={value}
        variant="number"
        decimalLimit={column.decimals}
      />
    );
  }

  return (
    <AutocompleteWrapper $scale={scale}>
      <FormattedAutocomplete
        value={value}
        options={column.options}
        onChange={handleChangeValue}
        onClose={handleCloseMenu}
        format={formatter.format}
      />
    </AutocompleteWrapper>
  );
});

export default SelectNumberValue;
